export default __webpack_public_path__ + "static/media/zdobycie_zetonu_udane.c3742d74.gif";